const getIsEmptyString = (text: string | null | undefined) => {
  return !text || text.length < 1 || text.trim() === "";
};

export default getIsEmptyString;
